import "rsuite/dist/rsuite.min.css";
import "./Styles/normalize.css";
import "react-toastify/dist/ReactToastify.css";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/en";
import { MantineProvider } from "@mantine/core";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { DatesProvider } from "@mantine/dates";
import { mantineTheme } from "@/app/theme";
import App from "./Containers/App/App";
import { setupStore } from "./Store/store";
import { DefaultTheme } from "./Theme/defaultTheme";

dayjs.extend(utc);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const store = setupStore();

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ThemeProvider theme={DefaultTheme}>
      <Provider store={store}>
        <GoogleOAuthProvider clientId="86935402230-5f0kf5aq2pq1tr698f8u13ctg2vm2vt9.apps.googleusercontent.com">
          <MantineProvider theme={mantineTheme}>
            <DatesProvider settings={{ locale: "en", firstDayOfWeek: 1 }}>
              <App />
            </DatesProvider>
          </MantineProvider>
        </GoogleOAuthProvider>
      </Provider>
    </ThemeProvider>
  </BrowserRouter>,
  // </React.StrictMode>,
);
